import type { ZabitBridge } from '../../renderer/src/global';

/**
 * Telefonun kendi kaydedicisi — yalnızca mobil uygulamada
 * (mobile/src/shims/nativeMic.ts). Web'de yok: kayıt tarayıcının mikrofonuyla.
 */
export const nativeMic: ZabitBridge['nativeMic'] = undefined;
